var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.16667L17.5 5V15L2.5 11.6667V9.16667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66677 13.9998C9.57922 14.3172 9.43002 14.6142 9.22769 14.8739C9.02535 15.1336 8.77385 15.3509 8.48754 15.5134C8.20122 15.6759 7.8857 15.7804 7.559 15.821C7.23229 15.8616 6.90079 15.8374 6.58343 15.7498C6.26607 15.6623 5.96906 15.5131 5.70936 15.3108C5.44966 15.1084 5.23236 14.8569 5.06985 14.5706C4.90735 14.2843 4.80283 13.9688 4.76227 13.6421C4.7217 13.3154 4.74588 12.9839 4.83343 12.6665",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMegaphone);
export default __webpack_public_path__ + "static/media/nav-megaphone.071a7fbe2238838927de3dc9d11d5466.svg";
export { ForwardRef as ReactComponent };